<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">库区管理</div> -->
    <div class="div-top">
      <!-- <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
        >新建开机/停机记录</el-button
      > -->

      <el-input
        v-if="!isLog"
        v-model="searchData.Code"
        clearable
        placeholder="请输入设备编号或名称"
        style="width: 300px; margin-left: 10px"
      ></el-input>
      <el-date-picker
        v-model="searchData.WorkOrderDate"
        type="monthrange"
        style="width: 300px; margin-left: 10px"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="handleDateChange"
      >
      </el-date-picker>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        @selection-change="handleSelect"
      >
        <!-- <el-table-column
          label=""
          width="50"
          type="selection"
          :selectable="selectable"
        >
        </el-table-column> -->
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>
        <el-table-column label="设备编号" align="center" prop="DeviceCode">
        </el-table-column>
        <el-table-column label="设备名称" align="center" prop="device_name">
        </el-table-column>
        <el-table-column label="类型" align="center" prop="Type">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.Type == 0">停机</el-tag>
            <el-tag type="success" v-if="scope.row.Type == 1">开机</el-tag>
            <!-- <el-tag type="warning" v-if="scope.row.Type == 2">故障</el-tag>
            <el-tag type="danger" v-if="scope.row.State == 3">报废</el-tag> -->
          </template>
        </el-table-column>
        <el-table-column label="停开机时间" align="center" prop="OperationDate">
          <template slot-scope="scope">
            {{
              scope.row.OperationDate
                ? moment(scope.row.OperationDate).format('YYYY-MM-DD HH:mm')
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <EditForm ref="EditForm" @success="handleSearch" />
  </div>
</template>
<script>
import EditForm from './EditForm'
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      moment,
      searchData: {
        Code: '',
        WorkOrderDate: [],
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {
    isLog: {
      type: Boolean,
      default: false,
    },
    devId: {
      type: String,
      default: '',
    },
  },
  components: { EditForm },
  methods: {
    handleDateChange(value) {
      // 无论是否为同一个月，结束日期都应为月末日期
      if (value && value.length === 2) {
        const startDate = moment(value[0])
        const endDate = moment(value[1])
        // 设置开始日期为选择月份的第一天
        const firstDay = startDate.startOf('month').format('YYYY-MM-DD')
        // 设置结束日期为选择月份的最后一天
        const lastDay = endDate.endOf('month').format('YYYY-MM-DD')
        this.$set(this.searchData, 'WorkOrderDate', [firstDay, lastDay])
      }
    },
    selectable(row) {
      if (row.State == '0') {
        return true
      } else {
        return false
      }
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device_StopPower/GetDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'OperationDate',
          SortType: 'Desc',
          Search: [
            {
              Condition: 'DeviceType',
              Keyword: this.devTreeSearch.DeviceType || '',
            },
            {
              Condition: 'BuildingId',
              Keyword: this.devTreeSearch.BuildingId || '',
            },
            {
              Condition: 'InstallationArea',
              Keyword: this.devTreeSearch.InstallationArea || '',
            },
            {
              Condition: 'Code',
              Keyword: this.searchData.Code,
            },
            {
              Condition: 'WorkOrderDate',
              Keyword: this.searchData.WorkOrderDate
                ? this.searchData.WorkOrderDate.join(',')
                : '',
            },
            {
              Condition: 'DeviceItemId',
              Keyword: this.devId || '',
            },
          ],
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
            this.pagination.total = resJson.Total
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.clearSelection()
              }
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建开机/停机记录')
    },

    handleEdit(row) {
      if (this.isLog) {
        this.$emit('view', row)
        return
      }
      this.$refs.EditForm.openForm('查看记录', row)
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {
    ...mapState(['devTreeSearch']),
  },
  watch: {
    devTreeSearch() {
      this.handleSearch()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
